// extracted by mini-css-extract-plugin
module.exports = {"calculator":"Zz5mc7","calculator__value":"AEybrD","calculator__value__inner":"_8XrGKO","calculator__keyboard":"Osi9kA","calculator__key":"vBdyIt"};